"use client";

import { Button } from "@/components/ui/button";
import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { useClientMotion } from '@/lib/hooks/use-reduced-motion-ssr';

const LandlordCTA = () => {
  const { MotionDiv, MotionH2, MotionP, motionProps } = useClientMotion();

  return (
    <div className="relative overflow-hidden">
      {/* Background with gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-white to-indigo-50 opacity-70" />
      
      {/* Decorative circles */}
      <MotionDiv 
        {...motionProps({
          animate: { 
            scale: [1, 1.2, 1],
            rotate: [0, 90, 0]
          },
          transition: { 
            duration: 20,
            repeat: Infinity,
            ease: "linear"
          }
        })}
        className="absolute -right-20 -top-20 w-40 h-40 rounded-full bg-blue-200 opacity-20"
      />
      <MotionDiv 
        {...motionProps({
          animate: { 
            scale: [1, 1.1, 1],
            rotate: [0, -90, 0]
          },
          transition: { 
            duration: 15,
            repeat: Infinity,
            ease: "linear"
          }
        })}
        className="absolute -left-10 -bottom-10 w-32 h-32 rounded-full bg-indigo-200 opacity-20"
      />

      {/* Content */}
      <div className="relative container mx-auto px-4 py-16 flex flex-col items-center text-center">
        <MotionH2 
          {...motionProps({
            initial: { opacity: 0, y: 20 },
            whileInView: { opacity: 1, y: 0 },
            transition: { duration: 0.6 }
          })}
          className="text-4xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent mb-4"
        >
          Landlord Reputation Explorer
        </MotionH2>
        
        <MotionP 
          {...motionProps({
            initial: { opacity: 0, y: 20 },
            whileInView: { opacity: 1, y: 0 },
            transition: { duration: 0.6, delay: 0.2 }
          })}
          className="text-xl text-gray-600 mb-8 max-w-lg"
        >
          Discover trusted landlord ratings and make informed rental decisions
        </MotionP>

        <MotionDiv
          {...motionProps({
            initial: { opacity: 0, y: 20 },
            whileInView: { opacity: 1, y: 0 },
            transition: { duration: 0.6, delay: 0.4 }
          })}
        >
          <Button 
            asChild
            className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-8 py-4 rounded-xl font-semibold
            transition-all duration-300 ease-out hover:shadow-lg transform-gpu hover:scale-105"
          >
            <Link href="/register">
              Get Started Today
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform transform-gpu" />
            </Link>
          </Button>
        </MotionDiv>
      </div>
    </div>
  );
};

export default LandlordCTA;
